import moment from 'moment';

export const convertToDateOnlyString = (dateTime) => {
  if (!dateTime) return null;

  let m;

  if (dateTime instanceof moment) {
    m = dateTime.clone();
  } else {
    dateTime = dateTime.slice(0, 10);
    m = moment(dateTime);
  }

  return m.format('YYYY-MM-DD');
};

export const convertToTimeOnlyString = (dateTime, isRailwayFormat) => {
  if (!dateTime) return null;

  let m = dateTime instanceof moment ? dateTime.clone() : moment(dateTime);

  return !m.isValid() && isRailwayFormat ? dateTime : m.format('HH:mm:ss');
};

export const convertToDateTimeOnlyString = (dateTime) => {
  if (!dateTime) return null;

  let m = dateTime instanceof moment ? dateTime.clone() : moment(dateTime);

  return m.format('YYYY-MM-DDTHH:mm:ss');
};

export const convertToDateTimeFormat2OnlyString = (dateTime) => {
  if (!dateTime) return null;

  let m = dateTime instanceof moment ? dateTime.clone() : moment(dateTime);

  return m.format('MM/DD/YYYY hh:mm:ss a');
};

export const timeTaken = (startTime, endTime) => {
  if (!startTime || !endTime) return null;

  let start =
    startTime instanceof moment ? startTime.clone() : moment(startTime);
  let end = endTime instanceof moment ? endTime.clone() : moment(endTime);
  let diffInSeconds = end.diff(start, 'seconds') % 60;
  let diffInMinutes = end.diff(start, 'minutes');
  return `${diffInMinutes} mins ${diffInSeconds} secs`;
};

export const convertToMomentTime = (dateTime) => {
  if (!dateTime) return null;
  let times = dateTime.split(':');

  let m = new Date();
  m.setHours(times[0], times[1], 0);
  m = moment(m);

  return m;
};

// perserves date, hour and min while changing the utc offset
// the time from database 2020-07-07T12:30:00.000-02:00'
// would be converted to '2020-07-07T12:30:00.000-07:00'
export const convertToLocalTimeWhileIgnoringOffset = (dateTime) => {
  if (!dateTime) {
    return null;
  }
  let date = dateTime.substring(0, 10);
  let [hour, minute, second] = dateTime.substring(11, 19).split(':');
  return moment(date).set({ hour, minute, second }).format();
};

// takes a local time and returns the time in UTC formated for the backend
export const convertToServerTime = (value) => {
  if (!value) return null;

  let m = value instanceof moment ? value.clone() : moment(value);

  return moment.utc(m).format();
};

export const convertToLocalTime = (value) => {
  if (!value) return null;

  return moment(moment(value).local().format());
};

export const convertToUTCTime = (value) => {
  if (!value) return null;

  return moment.utc(value).format();
};

export const convertToMomentFromTime = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof moment) {
    return value;
  }
  let splitTime = value.split(/:/);
  let momentTime = moment()
    .hours(parseInt(splitTime[0]))
    .minutes(parseInt(splitTime[1]))
    .seconds(parseInt(splitTime[2]));
  return momentTime;
};

export const convertToDateFormat2OnlyString = (dateTime) => {
  if (!dateTime) return null;

  const m = dateTime instanceof moment ? dateTime.clone() : moment(dateTime);

  return m.format('MM/DD/YYYY');
};
